import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader, Center } from "@mantine/core";

/**
 * ProtectedRoute - Wrapper component that protects routes from unauthorized access
 * Redirects to login if user is not authenticated
 */
function ProtectedRoute({
  children,
  allowedRoles = ["entrepreneur", "investor"],
}) {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <Center style={{ height: "70vh" }}>
        <Loader size="lg" />
      </Center>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user && allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return (
      <Navigate
        to={user.role === "investor" ? "/crowdfunding" : "/dashboard"}
        replace
      />
    );
  }

  return children;
}

export default ProtectedRoute;
